import html from 'html-template-string';
import Cookies from 'js-cookie'; // https://github.com/js-cookie/js-cookie
import dialogPolyfill from 'dialog-polyfill';
// some code taken from
// https://codepen.io/keithjgrant/pen/eyMMVL

function updateHashForDialog(dialog) {
    const dialogID = dialog.id;
    const url = `${document.location.pathname}#${dialogID}`;
    const oldHash = window.location.hash;

    if (window.history.replaceState) {
        window.history.replaceState(null, null, url);
    } else {
        window.location.hash = dialogID;
    }
    return oldHash;
}

function revertHashForDialog(dialog) {
    if (typeof dialog.dataset.oldHash !== 'undefined' || dialog.dataset.oldHash === null) {
        const id = dialog.dataset.oldHash.substring(1);
        let url = document.location.pathname;
        if (id.length) {
            url = `${url}#${id}`;
        }

        if (window.history.replaceState) {
            window.history.replaceState(null, null, url);
        } else {
            window.location.hash = id;
        }
    }
    return null;
}

/**
 * look to see if there are any dialogs referenced in the hash
 */

function checkHashForDialogs() {
    // are we on an overlay right now?
    const dialogID = window.location.hash.substring(1);

    if (dialogID.length) {
        const dialog = document.getElementById(dialogID);

        // did we find one?
        if (dialog && dialog.tagName === 'DIALOG') {
            dialog.showModal();
        } else { // maybe it's a dynamic one?
            const $button = document.querySelector(`[data-dialog="${dialogID}"]`);
            if ($button) {
                $button.click();
            }
        }
    }
}

/**
 * register dialog and add listeners
 * @param {Object} dialog - the dialog
 */
function setupDialog(dialog) {
    const close = dialog.querySelector('[data-dialog-close]');

    dialogPolyfill.registerDialog(dialog);

    // deal with any buttons
    const dialogBtns = dialog.querySelectorAll('button');

    if (dialogBtns.length) {
        Array.from(dialogBtns).forEach((btn) => {
            btn.addEventListener('click', () => {
                dialog.close(btn.value);
            });
        });
    }

    // close when clicking on backdrop
    dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
            dialog.close('cancelled');
        }
    });

    // close when clicking close button
    if (close) {
        close.addEventListener('click', () => {
            dialog.close('cancelled');
        });
    }

    // reset the hash on close
    dialog.addEventListener('close', function () {
        this.dataset.oldHash = revertHashForDialog(dialog);
    });
}

/**
 * Builds a dialog on the fly
 * @param {Object} opts - type and components for dialog
 * @param {String} opts.type - what type of dialog (dialog, overlay), defaults to 'dialog'
 * @param {String} opts.title - title of dialog
 * @param {String} opts.body - body of dialog
 * @param {String} opts.footer - footer of dialog
 * @param {String} opts.buttons - json array of buttons. Will be added to footer
 */
const buildDynamicDialog = (opts) => {
    const type = (typeof opts.type !== 'undefined') ? opts.type : 'dialog';
    const id = (typeof opts.id !== 'undefined') ? opts.id : '';
    const title = (typeof opts.title !== 'undefined') ? opts.title : '';
    const video = (typeof opts.video !== 'undefined') ? opts.video : '';
    const body = (typeof opts.body !== 'undefined') ? opts.body : '';
    const buttons = (typeof opts.buttons !== 'undefined') ? opts.buttons : false;
    const videoModifier = video.length ? '-video' : '';
    let footer = (typeof opts.footer !== 'undefined') ? opts.footer : '';
    let htmlstring = '';

    // console.log(opts);

    if (buttons !== false) {
        const buttonsArray = JSON.parse(buttons);
        const buttonsHtmlArray = buttonsArray.map((btn) => `
                <button class="Button -small" name="${btn.name}" value="${btn.value}">${btn.label}</button>
            `);
        footer += buttonsHtmlArray.join(' ');
    }
    switch (type) {
    case 'dialog':
        htmlstring = `<dialog class="Dialog ${videoModifier}" id="${id}"><header class="Dialog__header">`;
        if (title) {
            htmlstring += `<h1 class="Dialog__title">${title}</h1>`;
        }
        htmlstring += '<button class="Dialog__close Dialog_close" type="button" data-dialog-close>&times;</button></header>';
        if (body) {
            htmlstring += `<div class="Dialog__body">${body}</div>`;
        }
        if (video) {
            htmlstring += `
                <div class="Dialog__body -video">
                    <iframe
                        class="Dialog__video"
                        src="${video}"
                        frameborder="0"
                        allow="encrypted-media"
                        allowfullscreen>
                    </iframe>
                </div>`;
        }
        if (footer) {
            htmlstring += `<footer class="Dialog__footer">${footer}</footer>`;
        }
        htmlstring += '</dialog>';
        break;
    case 'overlay':
        htmlstring = `
                <dialog id="${id}" class="Overlay typography">
                <button class="Dialog__close Overlay__close" type="button" data-dialog-close>&times;</button>
                    <div class="Overlay__container">
                        <h2 class="Overlay__title">${title}</h2>
                        <div class="Overlay__content">
                            ${body}
                        </div>
                    </div>
                </dialog>
            `;
        break;
    default:
        htmlstring = false;
    }

    return htmlstring;
};

const moveDialogs = () => {
    const $dialogs = document.querySelectorAll('dialog:not(.-fake)');
    $dialogs.forEach(($dialog) => {
        document.querySelector('body').appendChild($dialog);
    });
};

const setUpDialogOpeners = () => {
    const buttons = document.querySelectorAll('[data-dialog]');
    if (buttons.length) {
        Array.from(buttons).forEach((button) => {
            // open on click
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const dialogID = button.dataset.dialog;
                const dialog = document.getElementById(dialogID);

                if (dialog) {
                    dialog.dataset.oldHash = updateHashForDialog(dialog);
                    dialog.showModal();
                } else {
                    const opts = {};
                    opts.id = button.dataset.dialog;

                    if (button.dataset.dialogType) {
                        opts.type = button.dataset.dialogType;
                    }

                    if (button.dataset.dialogTitle) {
                        opts.title = button.dataset.dialogTitle;
                    }

                    if (button.dataset.dialogBody) {
                        opts.body = button.dataset.dialogBody;
                    }

                    if (button.dataset.dialogVideo) {
                        opts.video = button.dataset.dialogVideo;
                    }

                    if (button.dataset.dialogFooter) {
                        opts.footer = button.dataset.dialogFooter;
                    }

                    if (button.dataset.dialogButtons) {
                        opts.buttons = button.dataset.dialogButtons;
                    }
                    // console.log(opts);
                    const dialogHtml = buildDynamicDialog(opts);
                    const $dynamicDialog = html`${dialogHtml}`;
                    document.querySelector('body').append($dynamicDialog);

                    setupDialog($dynamicDialog);
                    $dynamicDialog.dataset.oldHash = updateHashForDialog($dynamicDialog);
                    $dynamicDialog.showModal();

                    // delete dynamic dialogs when closed
                    $dynamicDialog.addEventListener('close', (evt) => {
                        evt.preventDefault();
                        $dynamicDialog.parentNode.removeChild($dynamicDialog);
                    });
                }
            });
        });
    }
};

// first, move any dialogs to the bottom of the page.
moveDialogs();

// set up dialogs
const dialogs = document.getElementsByTagName('dialog');

if (dialogs.length) {
    Array.from(dialogs).forEach((dialog) => {
        setupDialog(dialog);
    });
}

// set up openers
setUpDialogOpeners();

// are there any startopen dialogs?
let alreadyShown = false;
const startopens = document.querySelectorAll('[data-dialog-startopen]');
// console.log(startopens);
if (startopens && startopens.length) {
    startopens.forEach((dialog) => {
        const openIf = dialog.dataset.dialogStartopen.replace(/\s+/g, '-').toLowerCase();
        const cookieKey = `${openIf}-${dialog.id}`;
        const shown = Cookies.get(cookieKey);
        let openDialog = false;
        // console.log({shown, dialog, openIf, cookieKey});
        switch (openIf) {
        case 'always':
            openDialog = true;
            break;
        case 'only-once':
            if (!shown) {
                openDialog = true;
                Cookies.set(cookieKey, true, { expires: 365 });
            }
            break;
        case 'once-per-session':
        case 'session':
            if (!shown) {
                openDialog = true;
                Cookies.set(cookieKey, true);
            }
            break;
        case 'until-submitted':
            if (!shown) {
                // are we looking at a successful request?
                const uff = dialog.querySelector('#uff');
                if (uff) {
                    Cookies.set(cookieKey, true, { expires: 365 });
                    openDialog = true;
                } else {
                    openDialog = true;
                    const form = dialog.querySelector('form');
                    if (form) {
                        form.addEventListener('sumbit', (e) => {
                            e.preventDefault();
                            Cookies.set(cookieKey, true, { expires: 365 });
                        });
                    }
                }
            }
            break;
        default:
            break;
        }

        if (openDialog) {
            dialog.showModal();
            alreadyShown = true;
        }
    });
}

// check to see if we should be on a dialog from the hash
if (!alreadyShown) {
    checkHashForDialogs();
}
